import { brands } from '../../../constant/constant';
import BrandMarquee from './BrandMarquee';

const TrustedBrandsSection = () => (
  <BrandMarquee title="Our Brands" brands={brands} viewAllHref="/brands" />
);

export default TrustedBrandsSection;
